import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Statistics} from './statistics.js';
import {StatNames} from '../enums/StatNames.js';
import {Mathf} from '../utils/Mathf.js';
import {TransactionalNames} from '../enums/TransactionalNames.js';

export class RankManager extends Component {
    static TypeName = 'rank-manager';

    // starting xp to rank 1
    @property.int(2500)
    startingXpToRankUp = 2500;

    // how many points = 1 xp?
    @property.int(1000)
    scoreToXpConversion = 1000;

    // Singleton
    private static _instance: RankManager;
    static get instance(): RankManager {
        return RankManager._instance;
    }

    get currentRankPercentComplete(): number {
        const current = this.currentRankXp;
        const target = this.getXpTarget(this.rank);

        const percent = current / target;
        return percent;
    }

    get rank(): number {
        return Statistics.instance.getLong(StatNames.GameRank);
    }

    get currentRankXp(): number {
        return Statistics.instance.getLong(StatNames.CurrentRankXp);
    }

    init() {
        if (RankManager._instance) {
            console.error('There can only be one instance of RankManager Component');
        }
        RankManager._instance = this;
    }

    addXp(amount: number, giveReward: boolean) {
        const currentRank = this.rank;
        const currentXp = this.currentRankXp;

        let {newRank, newXp} = this.figureOutNewRank(
            currentRank,
            currentXp,
            amount,
            giveReward
        );

        Statistics.instance.record(StatNames.CurrentRankXp, newXp);
        Statistics.instance.record(StatNames.GameRank, newRank);
    }

    getXpTarget(rank: number): number {
        const targetXp = this.startingXpToRankUp * (rank + 1);
        return targetXp;
    }

    // When adding XP from another place
    figureOutNewRank(
        currentRank: number,
        currentXp: number,
        additionalXp: number,
        giveRewards: boolean
    ): {newRank: number; newXp: number} {
        // determine new xp
        let totalXp = currentXp + additionalXp;

        let rank = currentRank;
        // calculate the amount of XP needed to reach the next rank;
        let targetXp = this.getXpTarget(rank);

        // did you level up? if so, let's level you up..
        if (totalXp >= targetXp) {
            //get leftover xp
            totalXp = totalXp - targetXp;

            rank++;

            targetXp = this.getXpTarget(rank);

            if (giveRewards == true) {
                this.giveRewards(rank);
            }

            totalXp = 0;
        }

        return {newRank: rank, newXp: totalXp};
    }

    giveRewards(newRank: number) {
        //we removed set rewards.. now you always get a random reward from valid awards
        this._randomAwardFromValid();
    }

    scoreToXp(points: number): number {
        //convert score to xp
        let newXp = Math.ceil(points / this.scoreToXpConversion);

        // do you have xp doubler? if so, give double xp!
        if (
            Statistics.instance.getTransactional(TransactionalNames.CoinDoublerUnlocked) > 0
        ) {
            newXp *= 2;
        }

        return newXp;
    }

    private _randomAwardFromValid() {
        // List<int> rewardIndexes = Utils.RandomNonRepeatingValues(0,  randomPayouts.Length,  randomPayouts.Length);
        // for (int x = 0; x < randomPayouts.Length; x++)
        // {
        // 	int index = rewardIndexes[x];
        // 	if (Statistics.GetInstance().GetTransactional(randomPayouts[index].reward.statToCheckAgainstForValidity) > 0)
        // 	{
        // 		UnlockManager.GetInstance().PayOutReward(randomPayouts[index].reward, UnlockManager.PendingUnlockNotification.UnlockNotificationType.RankReward);
        // 		break;
        // 	}
        // }
    }
}
